export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';

export const UPDATE_BOARDSTATE = 'UPDATE_BOARDSTATE';
export const UPDATE_TICTAC_BOARDSTATE = 'UPDATE_TICTAC_BOARDSTATE';
export const TOGGLE_CURRENT_PLAYER = 'TOGGLE_CURRENT_PLAYER';
export const TOGGLE_CANPLAY = 'TOGGLE_CANPLAY';
export const TOGGLE_TTT_CANPLAY = 'TOGGLE_TTT_CANPLAY';
export const RESET_BOARDSTATE = 'RESET_BOARDSTATE';
export const RESET_TTT_BOARDSTATE = 'RESET_TTT_BOARDSTATE';

export const SET_WINNINGPLAYER = 'SET_WINNINGPLAYER';
export const SET_LASTPLAYED = 'SET_LASTPLAYED';
export const SET_CURRENT_PLAYER_NAME = 'SET_CURRENT_PLAYER_NAME';

export const SET_ROOM = 'SET_ROOM';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_USERS = 'SET_USERS';
export const SET_CURRENT_PLAYER = 'SET_CURRENT_PLAYER';
export const SET_FIRSTPLAYER_NAME = 'SET_FIRSTPLAYER_NAME';
export const SET_SERVER_CANPLAY = 'SET_SERVER_CANPLAY';

export const GET_PLAYER_PROFILE = 'GET_PLAYER_PROFILE';
export const CREATE_PLAYER_PROFILE = 'CREATE_PLAYER_PROFILE';
export const UPDATE_PLAYER_PROFILE = 'UPDATE_PLAYER_PROFILE';
export const PROFILES_LOADING = 'PROFILES_LOADING';

export const CREATE_NEW_ROOM = 'CREATE_NEW_ROOM';
export const UPDATE_ROOM_DATA = 'UPDATE_ROOM_DATA';
export const DELETE_ROOM = 'DELETE_ROOM';
export const GET_ROOMS_LIST = 'GET_ROOMS_LIST';
export const ROOMS_LOADING = 'ROOMS_LOADING';

export const SET_CHANGE_GAME_MODAL_OPEN = 'SET_CHANGE_GAME_MODAL_OPEN';
export const SET_PLAYER_SWITCH_APPROVAL = 'SET_PLAYER_SWITCH_APPROVAL';
export const SET_OPPONENT_SWITCH_APPROVAL = 'SET_OPPONENT_SWITCH_APPROVAL';

export const SET_RPS_WINNINGPLAYER = 'SET_RPS_WINNINGPLAYER';

export const INCR_C4_SCORE = 'INCR_C4_SCORE';
export const INCR_TTT_SCORE = 'INCR_TTT_SCORE';
export const INCR_RPS_SCORE = 'INCR_RPS_SCORE';
